import { gql, TypedDocumentNode } from '@common/hooks';
import {
  RecomputeScheduleReviewKpisMutationCgResponse,
  RecomputeScheduleReviewKpisMutationVariables,
} from '@common/graphql';

// TODO(WORK-6374): temporary. Forces a recompute of the live "Current" KPI moment so the
// Schedule Health strip reflects the latest output snapshot. Once post-run manual moves
// recompute the moment on change, this manual trigger (and the strip button) is removed.
export const RECOMPUTE_SCHEDULE_REVIEW_KPIS_MUTATION: TypedDocumentNode<
  RecomputeScheduleReviewKpisMutationCgResponse,
  RecomputeScheduleReviewKpisMutationVariables
> = gql`
  mutation RecomputeScheduleReviewKpis(
    $balancerRunId: ID!
    $organizationUnitId: ID!
  ) {
    recomputeScheduleReviewKpis(
      balancerRunId: $balancerRunId
      organizationUnitId: $organizationUnitId
    ) {
      balancerRunId
      organizationUnitId
    }
  }
`;
